import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { MenuItem } from 'src/app/app.models';
import { AppService } from 'src/app/app.service'; 
import { HostService } from 'src/app/services/host.service';
import {SinistreService } from  "src/app/services/sinistre.service";


@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss']
})
export class DetailsComponent implements OnInit {
 
  SinistreSubscription: Subscription;
 changeStatusSubscription: Subscription;
 sinisterGetted:boolean;
 statusChanged: boolean;
 public userIn: any;
 imageSinistre :Array<object>=[];
 sinistreId: any;
 public config: SwiperConfigInterface = { };
 displayedColumnsTemoins: string[] = ['nom', 'adresse', 'telephone'];
 displayedColumnsBlesser: string[] = ['nom', 'adresse', 'nature'];
 sinistres: any;
 temoins: [];
 blessers: [];
 vehicule:any;
 dataSourceTemoins!: MatTableDataSource<any>;
 dataSourceBlesser!: MatTableDataSource<any>;

 @ViewChild(MatPaginator, { static: true }) paginatorTemoin!: MatPaginator;
 @ViewChild(MatSort, { static: true }) sortTemoin!: MatSort;
 @ViewChild(MatPaginator, { static: true }) paginatorBlesser!: MatPaginator;
 @ViewChild(MatSort, { static: true }) sortBlesser!: MatSort;
 
  constructor(private sinisterService:SinistreService,
              public router: Router,
              private activetedRoute: ActivatedRoute,
              private hostService : HostService,
              public appService:AppService,
              private toastr: ToastrService,
              public dialog: MatDialog,
              public toast :ToastrService) { }

  ngOnInit(): void {
  
    this.loadData();

   const storageAuth = localStorage.getItem("user");
   
   if (storageAuth) {

     this.userIn = JSON.parse(storageAuth);

   }
    
  }


  loadData()
  {
    this.sinistreId = this.activetedRoute.snapshot.queryParamMap.get("code");
     this.SinistreSubscription=this.sinisterService.showSinisterVehicule(this.sinistreId).subscribe((res:any)=>{
        this.sinisterGetted=false;
        this.sinistres= res.sinistre;
        this.temoins= res.temoins;
        this.blessers= res.blesser;
 
        this.dataSourceTemoins = new MatTableDataSource<any>(this.temoins);
        this.dataSourceBlesser = new MatTableDataSource<any>(this.blessers);
        this.dataSourceTemoins.paginator = this.paginatorTemoin;
        this.dataSourceTemoins.sort = this.sortTemoin;
        this.dataSourceBlesser.paginator = this.paginatorBlesser;
        this.dataSourceBlesser.sort = this.sortBlesser;
 
        let images:Array<any> = res.image;
        images.forEach(elt=>{
          this.imageSinistre.push({
             image: this.hostService.getHttpsImage()+'/'+elt.image_url,
             thumbImage:this.hostService.getHttpsImage()+'/'+elt.image_url,
             alt: 'Image Sinistre'
           });
        });
      },error=>{
        this.toastr.show("Une erreur s'est produite veillez contacter votre administrateur","Erreur Erreur",
          {
            timeOut: 5000,
            closeButton: true,
          } as IndividualConfig,
          "toast-" + "error"
        );
        console.log(error);
      })
      this.statusChanged = false;
  }
 
 
  changeStatus(id:number,status:string)
  {
    this.sinisterService.updateStatutSinistre(id,status).subscribe((resp:any)=>{
      this.loadData();
      this.toast.success(resp.message,'Succès');
    },error=>{
      this.toast.error("Une erreur s'est produite veillez réessayer",'Erreur');
    })
  }
 
  ngOnDestroy(): void {
    if (this.sinisterGetted) {
      this.SinistreSubscription.unsubscribe();
    }
 
    if (this.statusChanged) {
      this.changeStatusSubscription.unsubscribe();
    }
    this.dialog.closeAll();
  }




}
